import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, ActionSheetController } from '@ionic/angular';
import { Trabajo } from '../../models/trabajo';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { firstValueFrom } from 'rxjs';
import { CotizacioneseditComponent } from '../cotizacionesedit/cotizacionesedit.component';
import { ComentariosComponent } from '../comentarios/comentarios.component';
import { CotizacionesmenuComponent } from '../cotizacionesmenu/cotizacionesmenu.component';
import { FacturamenuComponent } from '../facturamenu/facturamenu.component';
import { Browser } from '@capacitor/browser';
import { Share } from '@capacitor/share';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Metodosui } from '../../services/metodosui';
import { FilterGroup, SortOption, FilterResult } from '../../models/filtros.model';
import { FiltrosGenericosComponent } from '../filtros-genericos/filtros-genericos.component';

@Component({
  selector: 'app-cotizacioneslist',
  templateUrl: './cotizacioneslist.component.html',
  styleUrls: ['./cotizacioneslist.component.scss'],
  standalone: false
})
export class CotizacioneslistComponent implements OnInit {

  @Input() trabajo: Trabajo | null = null;
  @Input() viewMode: 'page' | 'modal' = 'modal';
  @Input() preloadedCotizaciones: any[] = [];
  @Input() selectionMode: boolean = false;
  @Input() parentType: 'solicitud' | 'trabajo' = 'trabajo';
  @Input() initialSpecialFilter: string = '';
  @Input() initialSearchText: string = '';
  @Input() cotizacionId: string | number | null = null;

  cotizaciones: any[] = [];
  filteredCotizaciones: any[] = [];
  displayedCotizaciones: any[] = [];
  estadosCotizacion: string[] = [];

  searchText: string = '';
  isLoading: boolean = false;

  // Filter & Sort
  selectedEstados: string[] = [];
  selectedSolicitantes: string[] = [];
  sortField: string = 'id';
  sortDirection: 'asc' | 'desc' = 'desc';
  uniqueSolicitantes: string[] = [];
  activeFiltersCount: number = 0;

  showOnlyPendingEnvios: boolean = false;
  showAprobadasSinOrdenArsEnviado: boolean = false;
  showAprobadasSinOrdenArsSinEnviar: boolean = false;
  showAprobadasConOrdenArsEnviado: boolean = false;
  showAprobadasConOrdenArsSinEnviar: boolean = false;
  showFacturadasPendientesPago: boolean = false;
  showOnlyPpts: boolean = false;
  activeCotizacionId: string | null = null;
  bitacoraStatus: { [key: string]: { correoFecha: string | null, arsFecha: string | null } } = {};

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private actionSheetCtrl: ActionSheetController,
    private router: Router,
    private route: ActivatedRoute,
    private javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private metodosUi: Metodosui
  ) { }

  async ngOnInit() {
    if (this.initialSearchText) {
      this.searchText = this.initialSearchText;
    }

    await this.loadEstados();
    this.selectedEstados = [...this.estadosCotizacion];

    this.route.queryParams.subscribe(params => {
      let needsFilter = false;

      if (params && params['search']) {
        this.searchText = String(params['search']);
        needsFilter = true;
      }

      if (params && params['estado']) {
        const estParam = String(params['estado']).toLowerCase();
        const matched = this.estadosCotizacion.find(e => e.toLowerCase() === estParam);
        if (matched) {
          this.selectedEstados = [matched];
          needsFilter = true;
        }
      }

      const especialParam = params ? (params['filtro'] || params['especial']) : null;
      if (especialParam) {
        if (especialParam === 'sin_envio') this.showOnlyPendingEnvios = true;
        if (especialParam === 'aprobadas_sin_orden_ars_enviado') this.showAprobadasSinOrdenArsEnviado = true;
        if (especialParam === 'aprobadas_sin_orden_ars_sin_enviar') this.showAprobadasSinOrdenArsSinEnviar = true;
        if (especialParam === 'aprobadas_con_orden_ars_enviado') this.showAprobadasConOrdenArsEnviado = true;
        if (especialParam === 'aprobadas_con_orden_ars_sin_enviar') this.showAprobadasConOrdenArsSinEnviar = true;
        if (especialParam === 'facturadas_pendientes_de_pago') this.showFacturadasPendientesPago = true;
        if (especialParam === 'aprobadas_con_ppt') this.showOnlyPpts = true;
        needsFilter = true;
      }

      if (needsFilter && this.cotizaciones && this.cotizaciones.length > 0) {
        this.applyFilters();
      }
    });

    if (this.initialSpecialFilter) {
      this.showOnlyPendingEnvios = this.initialSpecialFilter === 'sin_envio';
      this.showAprobadasSinOrdenArsEnviado = this.initialSpecialFilter === 'aprobadas_sin_orden_ars_enviado';
      this.showAprobadasSinOrdenArsSinEnviar = this.initialSpecialFilter === 'aprobadas_sin_orden_ars_sin_enviar';
      this.showAprobadasConOrdenArsEnviado = this.initialSpecialFilter === 'aprobadas_con_orden_ars_enviado';
      this.showAprobadasConOrdenArsSinEnviar = this.initialSpecialFilter === 'aprobadas_con_orden_ars_sin_enviar';
      this.showFacturadasPendientesPago = this.initialSpecialFilter === 'facturadas_pendientes_de_pago';
      this.showOnlyPpts = this.initialSpecialFilter === 'aprobadas_con_ppt';
    }

    if (this.preloadedCotizaciones && this.preloadedCotizaciones.length > 0) {
      this.cotizaciones = [...this.preloadedCotizaciones];
    } else {
      this.loadCotizaciones();
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  async loadEstados() {
    try {
      const resp: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral("genParStr", "getJsonParam", "estados_cotizacion", '', '', '', '', '', '', '', '', '', '', '', '', '', '')
        )
      );
      if (resp && resp.length > 0 && resp[0].dt1) {
        this.estadosCotizacion = JSON.parse(resp[0].dt1);
      } else {
        this.estadosCotizacion = ["Borrador", "Esperando datos", "En revision", "Corregir", "Enviada", "Aprobada", "Caducada", "Cancelada"];
      }
    } catch (e) {
      console.error('Error loading states:', e);
      this.estadosCotizacion = ["Borrador", "Esperando datos", "En revision", "Corregir", "Enviada", "Aprobada", "Caducada", "Cancelada"];
    }
  }

  async loadCotizaciones(silent: boolean = false, keepLength: boolean = false) {
    if (!silent) await this.metodosUi.showLoading('Cargando cotizaciones...', 'blue');
    try {
      let payload;
      if (this.selectionMode) {
        payload = this.metodosGenService.setModeloGeneral(
          "cotizaciones", "cotizacionesSinTrabajo", this.trabajo?.cliente || '', this.trabajo?.lugar || '', '', '', '', '', '', '', '', '', '', '', '', '', ''
        );
      } else if (this.trabajo && this.trabajo.id) {
        let subrutina = (this.parentType === 'solicitud') ? 'getInspeccionCotizacion' : 'cotizacionesT';
        payload = this.metodosGenService.setModeloGeneral(
          "cotizaciones", subrutina, String(this.trabajo.id), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
        );
      } else {
        payload = this.metodosGenService.setModeloGeneral(
          'cotizaciones', 'cotizacionesAll', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
        );
      }

      let data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      if (Array.isArray(data)) {
        if (this.cotizacionId) {
          data = data.filter((c: any) => String(c.dt1) === String(this.cotizacionId));
        }

        this.cotizaciones = data.map((c: any) => {
          const parts = (c.dt15 || '').split('|');
          const trabajoId = parts[0] || null;
          const hasOc = +(parts[1] || 0);
          const ocNumbersStr = parts[3] || '';
          const ocList = ocNumbersStr ? ocNumbersStr.split(',').map((s: string) => s.trim()) : [];
          
          const facturaIdsStr = parts[7] || '';
          const facturas = facturaIdsStr ? facturaIdsStr.split(',').map((pair: string) => {
            const [id, pagado] = pair.split(':');
            return { id: id.trim(), pagado: pagado === '1' };
          }) : [];
          const facturaFiscalStr = parts[8] || '';
          const [fiscalId, fiscalPagado] = facturaFiscalStr.split(':');
          const facturaFiscal = fiscalId ? { id: fiscalId, pagado: fiscalPagado === '1' } : null;

          const inspeccionId = (parts[9] && parts[9] !== '0') ? parts[9] : null;
          const pptMonto = (parts[10] ? +parts[10] : 0) || 0;

          return {
            id: c.dt1,
            fecha: c.dt2,
            cliente: c.dt3,
            precio: c.dt4,
            estado: c.dt5,
            direccion: c.dt6,
            descripcion: c.dt7,
            itbms: c.dt8,
            precioTotal: c.dt9,
            materiales: c.dt10,
            ppc: c.dt11,
            observacion: c.dt12,
            fechaCreacion: c.dt13,
            solicitante: c.dt14,
            trabajoId,
            inspeccionId,
            hasOc,
            ocList,
            facturas,
            facturaFiscal,
            pptMonto
          };
        });
      }
      await this.loadBitacoraStatuses();
      this.extractUniqueSolicitantes();
      this.applyFilters(keepLength);
    } catch (e) {
      console.error('Error loading cotizaciones:', e);
    } finally {
      if (!silent) await this.metodosUi.hideLoading();
    }
  }

  search(event: any) {
    this.searchText = (event.target?.value || '');
    this.applyFilters();
  }

  async openFilter() {
    const filters: FilterGroup[] = [
      {
        id: 'estados',
        label: 'Estados',
        icon: 'layers-outline',
        options: this.estadosCotizacion.map(e => ({ label: e, value: e })),
        selectedValues: [...this.selectedEstados]
      },
      {
        id: 'solicitantes',
        label: 'Solicitantes',
        icon: 'person-outline',
        options: this.uniqueSolicitantes.map(s => ({ label: s, value: s })),
        selectedValues: [...this.selectedSolicitantes]
      },
      {
        id: 'especiales',
        label: 'Especiales',
        icon: 'star-outline',
        options: [
          { label: 'Aprobadas Sin Envío', value: 'sin_envio' },
          { label: 'Aprobadas Sin Orden y ARS Enviado', value: 'aprobadas_sin_orden_ars_enviado' },
          { label: 'Aprobadas Sin Orden y ARS Sin Enviar', value: 'aprobadas_sin_orden_ars_sin_enviar' },
          { label: 'Aprobadas Con Orden y ARS Enviado', value: 'aprobadas_con_orden_ars_enviado' },
          { label: 'Aprobadas Con Orden y ARS Sin Enviar', value: 'aprobadas_con_orden_ars_sin_enviar' },
          { label: 'Facturadas Pendientes de Pago', value: 'facturadas_pendientes_de_pago' },
          { label: 'Aprobadas con PPT', value: 'aprobadas_con_ppt' }
        ],
        selectedValues: [
          ...(this.showOnlyPendingEnvios ? ['sin_envio'] : []),
          ...(this.showAprobadasSinOrdenArsEnviado ? ['aprobadas_sin_orden_ars_enviado'] : []),
          ...(this.showAprobadasSinOrdenArsSinEnviar ? ['aprobadas_sin_orden_ars_sin_enviar'] : []),
          ...(this.showAprobadasConOrdenArsEnviado ? ['aprobadas_con_orden_ars_enviado'] : []),
          ...(this.showAprobadasConOrdenArsSinEnviar ? ['aprobadas_con_orden_ars_sin_enviar'] : []),
          ...(this.showFacturadasPendientesPago ? ['facturadas_pendientes_de_pago'] : []),
          ...(this.showOnlyPpts ? ['aprobadas_con_ppt'] : [])
        ]
      }
    ];

    const sortOptions: SortOption[] = [
      { label: 'ID', field: 'id' },
      { label: 'Cliente', field: 'cliente' },
      { label: 'Dirección', field: 'direccion' },
      { label: 'Precio', field: 'precio' },
      { label: 'Fecha', field: 'fecha' }
    ];

    const res: FilterResult = await this.metodosUi.openModal(FiltrosGenericosComponent, {
      title: 'Filtros de Cotizaciones',
      subtitle: 'Configura la vista de presupuestos',
      filters: filters,
      sortOptions: sortOptions,
      currentSortField: this.sortField,
      currentSortDirection: this.sortDirection,
      themeColor: 'blue'
    });

    if (res) {
      this.selectedEstados = res.filters.find(f => f.id === 'estados')?.selectedValues || [];
      this.selectedSolicitantes = res.filters.find(f => f.id === 'solicitantes')?.selectedValues || [];
      
      const especiales = res.filters.find(f => f.id === 'especiales')?.selectedValues || [];
      this.showOnlyPendingEnvios = especiales.includes('sin_envio');
      this.showAprobadasSinOrdenArsEnviado = especiales.includes('aprobadas_sin_orden_ars_enviado');
      this.showAprobadasSinOrdenArsSinEnviar = especiales.includes('aprobadas_sin_orden_ars_sin_enviar');
      this.showAprobadasConOrdenArsEnviado = especiales.includes('aprobadas_con_orden_ars_enviado');
      this.showAprobadasConOrdenArsSinEnviar = especiales.includes('aprobadas_con_orden_ars_sin_enviar');
      this.showFacturadasPendientesPago = especiales.includes('facturadas_pendientes_de_pago');
      this.showOnlyPpts = especiales.includes('aprobadas_con_ppt');
      this.activeCotizacionId = null; 

      this.sortField = res.sortField;
      this.sortDirection = res.sortDirection;
      this.applyFilters();
    }
  }

  extractUniqueSolicitantes() {
    const set = new Set<string>();
    this.cotizaciones.forEach(c => {
      if (c.solicitante) set.add(c.solicitante);
    });
    this.uniqueSolicitantes = Array.from(set).sort();
  }

  setSort(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = field === 'id' ? 'desc' : 'asc';
    }
    this.applyFilters();
  }

  clearFilters() {
    this.selectedEstados = [...this.estadosCotizacion];
    this.selectedSolicitantes = [];
    this.showOnlyPendingEnvios = false;
    this.showAprobadasSinOrdenArsEnviado = false;
    this.showAprobadasSinOrdenArsSinEnviar = false;
    this.showAprobadasConOrdenArsEnviado = false;
    this.showAprobadasConOrdenArsSinEnviar = false;
    this.showFacturadasPendientesPago = false;
    this.showOnlyPpts = false;
    this.applyFilters();
  }

  applyFilters(keepLength: boolean = false) {
    let result = [...this.cotizaciones];
    const q = (this.searchText || '').toLowerCase();

    // Text search
    if (q) {
      result = result.filter(c =>
        (c.cliente || '').toLowerCase().includes(q) ||
        (c.descripcion || '').toLowerCase().includes(q) ||
        (c.direccion || '').toLowerCase().includes(q) ||
        (c.estado || '').toLowerCase().includes(q) ||
        (c.solicitante || '').toLowerCase().includes(q) ||
        String(c.id).includes(q)
      );
    }

    // Filtro temporal: Aprobadas sin envíos (Correo o ARS)
    if (this.showOnlyPendingEnvios) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        if (!isAprobada) return false;

        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        const correoFalta = !c.correoEnviadoFecha;
        const arsFalta = isDonAntonio && !c.arsEnviadoFecha;

        return correoFalta || arsFalta;
      });
    } else if (this.showAprobadasSinOrdenArsEnviado) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        const sinOc = !c.hasOc;
        const arsEnviado = !!c.arsEnviadoFecha;
        const sinFacturaFiscal = !c.facturaFiscal;
        return isAprobada && isDonAntonio && sinOc && arsEnviado && sinFacturaFiscal;
      });
    } else if (this.showAprobadasSinOrdenArsSinEnviar) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        const sinOc = !c.hasOc;
        const arsSinEnviar = !c.arsEnviadoFecha;
        const sinFacturaFiscal = !c.facturaFiscal;
        return isAprobada && isDonAntonio && sinOc && arsSinEnviar && sinFacturaFiscal;
      });
    } else if (this.showAprobadasConOrdenArsEnviado) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        const conOc = !!c.hasOc;
        const arsEnviado = !!c.arsEnviadoFecha;
        const sinFacturaFiscal = !c.facturaFiscal;
        return isAprobada && isDonAntonio && conOc && arsEnviado && sinFacturaFiscal;
      });
    } else if (this.showAprobadasConOrdenArsSinEnviar) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        const conOc = !!c.hasOc;
        const arsSinEnviar = !c.arsEnviadoFecha;
        const sinFacturaFiscal = !c.facturaFiscal;
        return isAprobada && isDonAntonio && conOc && arsSinEnviar && sinFacturaFiscal;
      });
    } else if (this.showFacturadasPendientesPago) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        const conOc = !!c.hasOc;
        const facturaFiscalPendiente = c.facturaFiscal && !c.facturaFiscal.pagado;
        return isAprobada && isDonAntonio && conOc && facturaFiscalPendiente;
      });
    } else if (this.showOnlyPpts) {
      result = result.filter(c => {
        const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
        return isAprobada && c.pptMonto > 0;
      });
    } else {
      // Filter by estado (Multiple) - Solo si no está el filtro especial activo
      if (this.selectedEstados.length > 0) {
        result = result.filter(c => this.selectedEstados.includes(c.estado));
      }

      // Filter by solicitante (Multiple) - Solo si no está el filtro especial activo
      if (this.selectedSolicitantes.length > 0) {
        result = result.filter(c => this.selectedSolicitantes.includes(c.solicitante));
      }
    }

    // selectionMode: Exclude invoiced quotations
    if (this.selectionMode) {
      result = result.filter(c => 
        (!c.facturas || c.facturas.length === 0) && 
        !c.facturaFiscal
      );
    }

    // Sort
    result.sort((a, b) => {
      let valA: any, valB: any;
      switch (this.sortField) {
        case 'id': valA = Number(a.id) || 0; valB = Number(b.id) || 0; break;
        case 'cliente': valA = (a.cliente || '').toLowerCase(); valB = (b.cliente || '').toLowerCase(); break;
        case 'direccion': valA = (a.direccion || '').toLowerCase(); valB = (b.direccion || '').toLowerCase(); break;
        case 'precio': valA = Number(a.precio) || 0; valB = Number(b.precio) || 0; break;
        case 'fecha': valA = a.fecha || ''; valB = b.fecha || ''; break;
        default: valA = Number(a.id) || 0; valB = Number(b.id) || 0;
      }
      const cmp = valA < valB ? -1 : valA > valB ? 1 : 0;
      return this.sortDirection === 'asc' ? cmp : -cmp;
    });

    this.filteredCotizaciones = result;
    const limit = keepLength && this.displayedCotizaciones ? Math.max(10, this.displayedCotizaciones.length) : 10;
    this.displayedCotizaciones = this.filteredCotizaciones.slice(0, limit);
    this.activeFiltersCount = this.selectedEstados.length + this.selectedSolicitantes.length;
  }

  /**
   * Detecta el scroll del div y carga más cotizaciones al acercarse al final.
   */
  onListScroll(event: Event) {
    const el = event.target as HTMLElement;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 150;
    if (nearBottom && this.displayedCotizaciones.length < this.filteredCotizaciones.length) {
      this.displayedCotizaciones = this.metodosGenService.loadMore(
        this.filteredCotizaciones, this.displayedCotizaciones, 10
      );
    }
  }

  trackByFn(index: number, item: any): any {
    return item.id;
  }

  getEstadoClass(estado: string): string {
    const e = (estado || '').toLowerCase();
    if (e === 'aprobada') return 'aprobada';
    if (e === 'borrador') return 'borrador';
    if (e === 'enviada') return 'enviada';
    if (e === 'rechazada' || e === 'cancelada') return 'rechazada';
    if (e === 'en revision' || e === 'esperando datos') return 'esperando';
    if (e === 'corregir') return 'corregir';
    return 'borrador';
  }

  countByEstado(estado: string): number {
    return this.cotizaciones.filter(c => (c.estado || '').toLowerCase() === estado.toLowerCase()).length;
  }

  async edit(cotizacion: any) {
    const modal = await this.modalCtrl.create({
      component: CotizacioneseditComponent,
      componentProps: {
        trabajo: this.trabajo,
        parentType: this.parentType,
        mode: 'edit',
        cotizacionId: cotizacion.id,
        cotizacionData: cotizacion // Pass full data for pre-filling
      }
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (data && data.action === 'saved') {
      this.loadCotizaciones();
    }
  }

  async clone(cotizacion: any) {
    const modal = await this.modalCtrl.create({
      component: CotizacioneseditComponent,
      componentProps: {
        trabajo: this.trabajo,
        parentType: this.parentType,
        mode: 'add',
        isClone: true,
        cotizacionId: cotizacion.id,
        cotizacionData: cotizacion
      }
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (data && data.action === 'saved') {
      this.loadCotizaciones();
    }
  }

  async addCotizacion() {
    if (this.trabajo) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: '¿Qué deseas hacer?',
        cssClass: 'custom-action-sheet',
        buttons: [
          {
            text: 'Crear nueva cotización',
            icon: 'add-circle-outline',
            handler: () => {
              this.showAddModal();
            }
          },
          {
            text: 'Vincular cotización existente',
            icon: 'link-outline',
            handler: () => {
              this.vincularExistente();
            }
          },
          {
            text: 'Cancelar',
            icon: 'close',
            role: 'cancel'
          }
        ]
      });
      await actionSheet.present();
    } else {
      this.showAddModal();
    }
  }

  async showAddModal() {
    const modal = await this.modalCtrl.create({
      component: CotizacioneseditComponent,
      componentProps: {
        trabajo: this.trabajo,
        parentType: this.parentType,
        mode: 'add'
      }
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
    if (data && data.action === 'saved') {
      this.loadCotizaciones();
    }
  }

  async vincularExistente() {
    const modal = await this.modalCtrl.create({
      component: CotizacioneslistComponent,
      componentProps: {
        trabajo: this.trabajo,
        selectionMode: true
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data?.linked) {
      this.loadCotizaciones();
    }
  }

  async delete(cotizacion: any) {
    const alert = await this.alertCtrl.create({
      header: 'Confirmar eliminación',
      message: '¿Estás seguro de que deseas eliminar esta cotización?',
      cssClass: 'custom-alert',
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'alert-button' },
        {
          text: 'Eliminar',
          role: 'destructive',
          cssClass: 'danger-btn',
          handler: async () => {
            try {
              const userJson = localStorage.getItem('user');
              let usuario = '';
              if (userJson) {
                const user = JSON.parse(userJson);
                usuario = user.l_usuario || '';
              }

              const deletePayload = {
                id: cotizacion.id,
                cliente: cotizacion.cliente,
                direccion: cotizacion.direccion || cotizacion.trabajoLugar
              };

              await firstValueFrom(this.javapiService.eliminaCotizacion({
                cotizacion: deletePayload,
                usuario: usuario
              }));
              this.loadCotizaciones();
            } catch (e) {
              console.error("Error deleting", e);
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async changeStatus(cotizacion: any) {
    const currentEstado = (cotizacion?.estado || '').toLowerCase();
    let availableEstados = [...this.estadosCotizacion];

    // Restricciones de estado
    if (currentEstado === 'enviada') {
      availableEstados = ['Aprobada'];
    } else if (currentEstado === 'aprobada') {
      availableEstados = ['Cancelada'];
    }

    const buttons = availableEstados
      .filter(estado => estado !== cotizacion.estado)
      .map(estado => {
        // Determine icon and color based on the state name
        let icon = 'ellipse-outline';
        let cssClass = 'action-sheet-default';
        const e = (estado || '').toLowerCase();

        if (e === 'aprobada') { icon = 'checkmark-circle'; cssClass = 'action-sheet-success'; }
        else if (e === 'borrador') { icon = 'document'; cssClass = 'action-sheet-gray'; }
        else if (e === 'enviada') { icon = 'send'; cssClass = 'action-sheet-blue'; }
        else if (e === 'rechazada' || e === 'cancelada') { icon = 'close-circle'; cssClass = 'action-sheet-danger'; }
        else if (e === 'en revision' || e === 'esperando datos') { icon = 'time'; cssClass = 'action-sheet-warning'; }
        else if (e === 'corregir') { icon = 'alert-circle'; cssClass = 'action-sheet-warning'; }

        return {
          text: estado,
          icon: icon,
          cssClass: cssClass,
          handler: () => {
            if (e === 'aprobada' || e === 'enviada') {
              this.executeStatusChange(cotizacion, estado, '');
            } else {
              this.askStatusComment(cotizacion, estado);
            }
          }
        };
      });

    buttons.push({
      text: 'Cancelar',
      icon: 'close',
      role: 'cancel',
      cssClass: 'action-sheet-cancel',
      handler: () => { }
    } as any);

    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Actualizar Estado a:',
      buttons: buttons,
      cssClass: 'custom-action-sheet'
    });

    await actionSheet.present();
  }

  async askStatusComment(cotizacion: any, nuevoEstado: string) {
    const alert = await this.alertCtrl.create({
      header: 'Motivo del cambio de estado',
      subHeader: 'Dejar un comentario para el registro',
      cssClass: 'custom-alert',
      inputs: [
        {
          name: 'comentario',
          type: 'textarea',
          placeholder: 'Escribe un comentario o justificación...',
          cssClass: 'custom-textarea'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'alert-button btn-cancel'
        },
        {
          text: 'Guardar',
          cssClass: 'alert-button btn-save',
          handler: async (data) => {
            let comentarioStr = data.comentario ? data.comentario.trim() : '';
            await this.executeStatusChange(cotizacion, nuevoEstado, comentarioStr);
          }
        }
      ]
    });
    await alert.present();
  }

  private async executeStatusChange(cotizacion: any, nuevoEstado: string, comentario: string) {
    try {
      const userJson = localStorage.getItem('user');
      let usuario = '';
      if (userJson) {
        const user = JSON.parse(userJson);
        usuario = user.l_usuario || '';
      }

      const payload = this.metodosGenService.setModeloGeneral(
        "cotizaciones", "cotizacionStatusUpdate",
        String(cotizacion.id),
        nuevoEstado,
        comentario,
        usuario,
        '', '', '', '', '', '', '', '', '', '', ''
      );

      const res: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      if (res) {
        await this.loadCotizaciones();
      }
    } catch (e) {
      console.error('Error updating status:', e);
    }
  }

  async verComentarios(cotizacion: any) {
    const modal = await this.modalCtrl.create({
      component: ComentariosComponent,
      componentProps: {
        modulo: 'COTIZACIONES',
        referencia_id: cotizacion.id,
        titulo_referencia: `Cotización: ${cotizacion.cliente || ''}`
      },
      cssClass: 'modal-half-screen' // Optional: if you have a half screen style
    });

    await modal.present();

    // Refresh if any comment was added
    const { data } = await modal.onWillDismiss();
    // this.loadCotizaciones(); // Removed to prevent scrolling refresh
  }

  async viewPdf(c: any) {
    const url = this.javapiService.getFileUrl('COT', c.id, false);
    await Browser.open({ url });
  }

  async downloadPdf(c: any) {
    await this.metodosUi.showLoading('Descargando PDF...', 'blue');
    try {
      const url = this.javapiService.getFileUrl('COT', c.id, false);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Error al descargar');
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      let prefijo = 'PG-COT_';
      try {
        const paramRes = await firstValueFrom(this.javapiService.getJsonParam('CT_ARCHIVOS'));
        if (paramRes && paramRes.pa_json) {
          const config = JSON.parse(paramRes.pa_json);
          prefijo = config.COTIZACION || 'PG-COT_';
        }
      } catch (err) {}

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${prefijo}${c.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      await this.metodosUi.hideLoading();
      this.metodosUi.showToast('Descarga iniciada', 'success');
    } catch (e) {
      await this.metodosUi.hideLoading();
      const url = this.javapiService.getFileUrl('COT', c.id, true);
      await Browser.open({ url });
    }
  }

  async sharePdf(c: any) {
    await this.metodosUi.showLoading('Preparando PDF para compartir...', 'blue');
    try {
      const url = this.javapiService.getFileUrl('COT', c.id, false);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Error al descargar el archivo');
      const blob = await response.blob();

      let prefijo = 'PG-COT_';
      try {
        const paramRes = await firstValueFrom(this.javapiService.getJsonParam('CT_ARCHIVOS'));
        if (paramRes && paramRes.pa_json) {
          const config = JSON.parse(paramRes.pa_json);
          prefijo = config.COTIZACION || 'PG-COT_';
        }
      } catch (err) {}

      // Convertir Blob a Base64 para guardarlo nativamente
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        try {
          const base64data = reader.result as string;
          const base64Raw = base64data.split(',')[1];

          const fileName = `${prefijo}${c.id}.pdf`;
          
          // Guardar en la caché nativa del móvil
          const savedFile = await Filesystem.writeFile({
            path: fileName,
            data: base64Raw,
            directory: Directory.Cache
          });

          await this.metodosUi.hideLoading();

          // Compartir archivo nativo real (WhatsApp, Gmail, Drive, etc.)
          await Share.share({
            title: `Cotización #${c.id}`,
            url: savedFile.uri
          });
        } catch (innerErr) {
          console.error('Error en proceso nativo de compartir:', innerErr);
          await this.metodosUi.hideLoading();
          // Fallback a apertura en navegador externo
          await Browser.open({ url });
        }
      };
    } catch (e: any) {
      await this.metodosUi.hideLoading();
      console.error('Error al descargar para compartir:', e);
      try {
        const url = this.javapiService.getFileUrl('COT', c.id, false);
        await Browser.open({ url });
      } catch (err) {}
    }
  }

  async viewInvoicePdf(invoiceId: any) {
    // 1. Fetch invoice basic data to open the menu
    try {
      const payload = this.metodosGenService.setModeloGeneral(
        'genModel', 'factura_empresa_creadas',
        String(invoiceId), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
      );
      const data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      
      if (Array.isArray(data) && data.length > 0) {
        const f = data[0];
        const factura = {
          id: f.dt1,
          fecha: f.dt2,
          cliente: f.dt3,
          total: +f.dt4,
          usuario: f.dt5,
          fecha_creacion: f.dt6,
          estado: f.dt7,
          direccion: f.dt8,
          subtotal: +f.dt9,
          itbms: +f.dt10,
          cotizacionId: f.dt11
        };

        const modal = await this.modalCtrl.create({
          component: FacturamenuComponent,
          componentProps: { factura },
          cssClass: 'bottom-sheet-modal'
        });
        await modal.present();

        const { data: menuData } = await modal.onDidDismiss();
        if (menuData && menuData.action === 'delete') {
            this.loadCotizaciones(true);
        }
      } else {
        // Fallback to direct PDF if data can't be loaded
        const url = this.javapiService.getFileUrl('FAC', invoiceId, false);
        await Browser.open({ url });
      }
    } catch (e) {
      console.error('Error opening invoice menu:', e);
      // Fallback
      const url = this.javapiService.getFileUrl('FAC', invoiceId, false);
      await Browser.open({ url });
    }
  }

  async presentPdfOptions(c: any) {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Opciones de PDF',
      cssClass: 'custom-action-sheet',
      buttons: [
        {
          text: 'Ver PDF',
          icon: 'eye-outline',
          handler: () => {
            this.viewPdf(c);
          }
        },
        {
          text: 'Compartir PDF',
          icon: 'share-social-outline',
          handler: () => {
            this.sharePdf(c);
          }
        },
        {
          text: 'Descargar PDF',
          icon: 'cloud-download-outline',
          handler: () => {
            this.downloadPdf(c);
          }
        },
        {
          text: 'Cancelar',
          icon: 'close',
          role: 'cancel'
        }
      ]
    });
    await actionSheet.present();
  }

  async openMenu(c: any) {
    if (this.selectionMode) {
      this.confirmLink(c);
      return;
    }

    const modal = await this.modalCtrl.create({
      component: CotizacionesmenuComponent,
      componentProps: {
        cotizacion: c,
        trabajo: this.trabajo
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();

    if (data?.action === 'edit') {
      this.edit(data.cotizacion);
    } else if (data?.action === 'clone') {
      this.clone(data.cotizacion);
    } else if (data?.action === 'delete') {
      this.delete(data.cotizacion);
    } else if (data?.action === 'goToTrabajo') {
      // Close all modals then navigate to the specific trabajo menu
      const trabajoId = data.trabajoId;
      try { await this.modalCtrl.dismiss(); } catch (_) { }
      this.router.navigate(['/menu/trabajos'], { queryParams: { openTrabajoId: trabajoId } });
    } else {
      // Refresh to pick up any status changes made inside the menu, keeping current page load
      await this.loadCotizaciones(true, true);
    }
  }

  async confirmLink(cotizacion: any) {
    if (!this.trabajo) return;

    const targetName = this.parentType === 'solicitud' ? 'esta solicitud' : 'este trabajo';
    const alert = await this.alertCtrl.create({
      header: 'Confirmar vinculación',
      message: `¿Deseas vincular la cotización #${cotizacion.id} de ${cotizacion.cliente} a ${targetName}?`,
      cssClass: 'custom-alert',
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'alert-button btn-cancel' },
        {
          text: 'Vincular',
          cssClass: 'alert-button btn-save',
          handler: async () => {
            await this.executeLink(cotizacion);
          }
        }
      ]
    });
    await alert.present();
  }

  async executeLink(cotizacion: any) {
    if (!this.trabajo) return;
    try {
      this.metodosUi.showLoading('Vinculando...');
      const usuario = this.metodosGenService.getUsuario();

      let rutina = "genUpdate";
      let subrutina = "linkCotizacionTrabajo";
      let d1 = String(cotizacion.id);
      let d2 = String(this.trabajo.id);

      // Si el origen es una solicitud (inspección), usamos la subrutina adecuada
      if (this.parentType === 'solicitud') {
        subrutina = "linkInspeccionCotizacion";
        d1 = String(this.trabajo.id); // ID de la Inspección
        d2 = String(cotizacion.id);    // ID de la Cotización
      }

      const payload = this.metodosGenService.setModeloGeneral(
        'cotizaciones', subrutina,
        d1, d2, usuario,
        '', '', '', '', '', '', '', '', '', '', '', ''
      );

      const res = await firstValueFrom(this.javapiService.getCommonModel(payload));
      this.metodosUi.hideLoading();

      if (res) {
        if (this.parentType !== 'solicitud') {
          try {
            const updatePayload = this.metodosGenService.setModeloGeneral(
              "cotizaciones", "cotizacionStatusUpdate",
              String(cotizacion.id),
              "Aprobada",
              "Aprobada automáticamente al vincular al trabajo",
              usuario,
              '', '', '', '', '', '', '', '', '', '', ''
            );
            await firstValueFrom(this.javapiService.getCommonModel(updatePayload));
          } catch (statusErr) {
            console.error('Error auto-approving quotation status on link:', statusErr);
          }
        }
        this.metodosUi.showToast('Vínculo realizado con éxito', 'success');
        this.modalCtrl.dismiss({ linked: true, c_id: cotizacion.id });
      }
    } catch (e) {
      this.metodosUi.hideLoading();
      console.error('Error linking cotizacion:', e);
      this.metodosUi.showToast('Error al vincular: ' + e, 'danger');
    }
  }

  // --------------------------------------------------------------------------
  // NUEVA LÓGICA DE BITÁCORA Y ENVÍOS TEMPORALES
  // --------------------------------------------------------------------------

  async loadBitacoraStatuses() {
    try {
      const jobId = this.trabajo?.id ? String(this.trabajo.id) : "0";
      const payload = this.metodosGenService.setModeloGeneral(
        "bitacora_cotizaciones", "GET_STATUS_TRABAJO",
        jobId, "", "", "", "", "", "", "", "", "", "", "", "", "", ""
      );
      const data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      if (Array.isArray(data)) {
        this.bitacoraStatus = {};
        data.forEach(item => {
          this.bitacoraStatus[String(item.dt1)] = {
            correoFecha: item.dt2 || null,
            arsFecha: item.dt3 || null
          };
        });

        // Enlazar los datos a las cotizaciones
        this.cotizaciones.forEach(c => {
          const status = this.bitacoraStatus[String(c.id)];
          c.correoEnviadoFecha = status?.correoFecha || null;
          c.arsEnviadoFecha = status?.arsFecha || null;
        });
      }
    } catch (e) {
      console.error('Error cargando bitácora de cotizaciones:', e);
    }
  }

  hasPendingCorreo(): boolean {
    return this.cotizaciones.some(c => {
      const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
      return isAprobada && !c.correoEnviadoFecha;
    });
  }

  hasPendingArs(): boolean {
    return this.cotizaciones.some(c => {
      const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
      const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
      return isAprobada && isDonAntonio && !c.arsEnviadoFecha;
    });
  }

  getPendingEnviosCount(): number {
    return this.cotizaciones.filter(c => {
      const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
      if (!isAprobada) return false;

      const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
      const correoFalta = !c.correoEnviadoFecha;
      const arsFalta = isDonAntonio && !c.arsEnviadoFecha;

      return correoFalta || arsFalta;
    }).length;
  }

  togglePendingEnvios() {
    this.showOnlyPendingEnvios = !this.showOnlyPendingEnvios;
    this.activeCotizacionId = null; 
    this.applyFilters();
  }

  async seleccionarYRegistrarEnvio(comentario: 'Correo enviado' | 'ARS enviado') {
    const isCorreo = comentario === 'Correo enviado';
    
    // Obtener cotizaciones aprobadas que les falte este envío
    const candidatos = this.cotizaciones.filter(c => {
      const isAprobada = (c.estado || '').toLowerCase() === 'aprobada';
      if (!isAprobada) return false;

      if (isCorreo) {
        return !c.correoEnviadoFecha;
      } else {
        const isDonAntonio = (c.cliente || '').toLowerCase().includes('don antonio');
        return isDonAntonio && !c.arsEnviadoFecha;
      }
    });

    if (candidatos.length === 0) {
      this.metodosUi.showToast(`No hay cotizaciones pendientes de registrar ${isCorreo ? 'correo' : 'ARS'}.`, 'info');
      return;
    }

    // Si solo hay un candidato, ir directo a pedir la fecha
    if (candidatos.length === 1) {
      this.activeCotizacionId = candidatos[0].id;
      await this.registrarEnvio(comentario);
      return;
    }

    // Si hay múltiples candidatos, abrir Action Sheet para seleccionar
    const buttons = candidatos.map(c => ({
      text: `#${c.id} - ${c.cliente}`,
      icon: isCorreo ? 'mail-outline' : 'document-outline',
      handler: () => {
        this.activeCotizacionId = c.id;
        this.registrarEnvio(comentario);
      }
    }));

    buttons.push({
      text: 'Cancelar',
      icon: 'close',
      role: 'cancel'
    } as any);

    const actionSheet = await this.actionSheetCtrl.create({
      header: `Selecciona la cotización a registrar:`,
      buttons: buttons,
      cssClass: 'custom-action-sheet'
    });

    await actionSheet.present();
  }

  async registrarEnvioDirecto(cotizacion: any, comentario: 'Correo enviado' | 'ARS enviado') {
    this.activeCotizacionId = cotizacion.id;
    await this.registrarEnvio(comentario);
  }

  async registrarEnvio(comentario: 'Correo enviado' | 'ARS enviado') {
    if (!this.activeCotizacionId) return;

    const isCorreo = comentario === 'Correo enviado';
    const title = isCorreo ? '✉️ Enviar Cotización' : '📄 Enviar ARS';
    const subTitle = isCorreo ? 'Fecha en que se envió la cotización al cliente:' : 'Fecha de entrega del reporte ARS firmado:';
    const cssClass = isCorreo ? 'custom-alert alert-envio-correo' : 'custom-alert alert-envio-ars';
    const today = new Date().toISOString().substring(0, 10);

    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: subTitle,
      cssClass: cssClass,
      inputs: [
        {
          name: 'fecha',
          type: 'date',
          value: today,
          min: '2020-01-01',
          max: today
        }
      ],
      buttons: [
        { text: 'Cancelar', role: 'cancel', cssClass: 'alert-button btn-cancel' },
        {
          text: 'Registrar',
          cssClass: 'alert-button btn-save',
          handler: (data: any) => {
            if (!data.fecha) {
              this.metodosUi.showToast('Debes seleccionar una fecha', 'warning');
              return false;
            }
            this.executeRegistrarEnvio(this.activeCotizacionId!, comentario, data.fecha);
            return true;
          }
        }
      ]
    });
    await alert.present();
  }

  private async executeRegistrarEnvio(cotId: string, comentario: string, fecha: string) {
    await this.metodosUi.showLoading('Guardando registro...', 'blue');
    try {
      const usuario = this.metodosGenService.getUsuario();
      const payload = this.metodosGenService.setModeloGeneral(
        "bitacora_cotizaciones", "INSERT",
        cotId, comentario, usuario, fecha,
        "", "", "", "", "", "", "", "", "", "", ""
      );
      const res = await firstValueFrom(this.javapiService.getCommonModel(payload));
      if (res) {
        this.metodosUi.showToast('Envío registrado con éxito', 'success');
        await this.loadCotizaciones(true, true);
        
        // Mantener selección si aún falta algún envío
        const updatedCot = this.cotizaciones.find(c => String(c.id) === String(cotId));
        if (updatedCot && updatedCot.correoEnviadoFecha && updatedCot.arsEnviadoFecha) {
          this.activeCotizacionId = null; 
        }
      }
    } catch (e) {
      console.error('Error al registrar envío:', e);
      this.metodosUi.showToast('Error al guardar registro: ' + e, 'danger');
    } finally {
      await this.metodosUi.hideLoading();
    }
  }

}
